import script from "./SaveStatusIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveStatusIndicator.vue?vue&type=script&setup=true&lang=js"

import "./SaveStatusIndicator.vue?vue&type=style&index=0&id=575dc338&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-575dc338"]])

export default __exports__